"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Spinner_1 = require("../Spinner");
var LoadingContent = function (_a) {
    var loading = _a.loading, colSpan = _a.colSpan;
    if (!loading) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("tbody", { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", __assign({ colSpan: colSpan }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-flex squid-justify-center squid-items-center squid-h-[200px]" }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { color: "primary", size: "3xl" }) })) })) }) }));
};
exports.default = LoadingContent;
